import { bankDetailsListValidationSchema } from 'pages/BankAccount/BankDetailsTab/BankDetailsSchema';

export const  validationSchemaClosureRevision = () => bankDetailsListValidationSchema(); 